// HelpCenter.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form, Badge } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaClock, FaHeadset, FaQuestionCircle, FaComments, FaUsers, FaWhatsapp, FaTimes, FaPaperPlane, FaCircle } from 'react-icons/fa';

const HelpCenter = () => {
  const [showChat, setShowChat] = useState(false);
  const [chatMessage, setChatMessage] = useState('');
  const [messageSent, setMessageSent] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  const teamMembers = [
    {
      name: "Nitesh Mandal",
      email: "niteshmandal@zohomail.in",
      photo: "/api/placeholder/150/150",
      role: "Owner",
      phone: "+91 XXXXX XXXXX"
    },
    // {
    //   name: "Nisha Paul",
    //   email: "nishapaul4137@gmail.com",
    //   photo: "/api/placeholder/150/150",
    //   role: "Technical Support",
    //   phone: "+91 XXXXX XXXXX"
    // },
    // {
    //   name: "Satyam Shukla",
    //   email: "shukla98satyam@zohomail.in",
    //   photo: "/api/placeholder/150/150",
    //   role: "Technical Support",
    //   phone: "+91 XXXXX XXXXX"
    // },
    {
      name: "Rishabh Mandal",
      email: "rishabhmandal60@zohomail.in",
      photo: "/api/placeholder/150/150",
      role: "Customer Support",
      phone: "+91 XXXXX XXXXX"
    }
  ];

  const faqItems = [
    {
      question: "How do I reset my password?",
      answer: "You can reset your password by clicking on 'Forgot Password' on the login page."
    },
    {
      question: "How can I update my profile information?",
      answer: "Go to Settings > Profile to update your personal information and preferences."
    },
    {
      question: "What are your support hours?",
      answer: "Our support team is available Monday to Friday, 9:00 AM to 6:00 PM IST."
    },
    {
      question: "How do I contact technical support?",
      answer: "You can reach our technical support team via email or through the contact form below."
    }
  ];

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!chatMessage.trim()) return;
    setMessageSent(true);
    setChatMessage('');
    setTimeout(() => setMessageSent(false), 4000);
  };

  const onlineAgents = teamMembers.filter((_, i) => i < 2);

  return (
    <>
      {/* Live Chat Modal */}
      <Modal show={showChat} onHide={() => setShowChat(false)} centered size="md">
        <Modal.Header className="border-0 pb-0" style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)' }}>
          <div className="d-flex align-items-center w-100">
            <div className="me-3">
              <FaComments className="text-white" size={28} />
            </div>
            <div className="flex-grow-1">
              <h5 className="text-white mb-0 fw-bold">Live Chat Support</h5>
              <small className="text-white-50">We typically reply within minutes</small>
            </div>
            <button
              className="btn btn-link text-white p-0"
              onClick={() => setShowChat(false)}
              style={{ fontSize: '1.2rem' }}
            >
              <FaTimes />
            </button>
          </div>
        </Modal.Header>

        <Modal.Body className="p-0">
          {/* Online Agents */}
          <div className="p-3" style={{ background: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}>
            <small className="text-muted fw-semibold text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Available Agents</small>
            <div className="d-flex gap-3 mt-2">
              {onlineAgents.map((agent, i) => (
                <div
                  key={i}
                  className={`d-flex align-items-center p-2 rounded-3 cursor-pointer chat-agent-card ${selectedAgent?.name === agent.name ? 'selected-agent' : ''}`}
                  style={{ cursor: 'pointer', border: selectedAgent?.name === agent.name ? '2px solid #0d6efd' : '2px solid transparent', background: '#fff', flex: 1 }}
                  onClick={() => setSelectedAgent(agent)}
                >
                  <div className="position-relative me-2">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                      style={{ width: 38, height: 38, background: i === 0 ? '#0d6efd' : '#198754', fontSize: '0.85rem' }}
                    >
                      {agent.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <FaCircle size={10} className="text-success position-absolute" style={{ bottom: 0, right: 0, background: '#fff', borderRadius: '50%' }} />
                  </div>
                  <div>
                    <div className="fw-semibold" style={{ fontSize: '0.8rem', lineHeight: 1.2 }}>{agent.name.split(' ')[0]}</div>
                    <div style={{ fontSize: '0.7rem', color: '#6c757d' }}>{agent.role.split(' ')[0]}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Message Area */}
          <div className="p-3">
            {messageSent ? (
              <div className="text-center py-4">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
                  style={{ width: 60, height: 60, background: '#d1fae5' }}
                >
                  <FaPaperPlane className="text-success" size={22} />
                </div>
                <h6 className="text-success fw-bold">Message Sent!</h6>
                <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
                  {selectedAgent ? `${selectedAgent.name} will get back to you soon.` : 'Our team will get back to you shortly.'}
                </p>
              </div>
            ) : (
              <Form onSubmit={handleSendMessage}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold" style={{ fontSize: '0.875rem' }}>Your Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter your name" size="sm" required style={{ borderRadius: 8 }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold" style={{ fontSize: '0.875rem' }}>Email Address</Form.Label>
                  <Form.Control type="email" placeholder="Enter your email" size="sm" required style={{ borderRadius: 8 }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold" style={{ fontSize: '0.875rem' }}>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Describe your issue or question..."
                    value={chatMessage}
                    onChange={(e) => setChatMessage(e.target.value)}
                    required
                    style={{ borderRadius: 8, resize: 'none' }}
                  />
                </Form.Group>
                <div className="d-grid">
                  <Button
                    type="submit"
                    variant="primary"
                    style={{ borderRadius: 8, background: 'linear-gradient(135deg, #0d6efd, #0a58ca)', border: 'none' }}
                  >
                    <FaPaperPlane className="me-2" size={14} />
                    Send Message
                  </Button>
                </div>
              </Form>
            )}
          </div>

          {/* Quick Contact */}
          <div className="p-3 pt-0">
            <div className="text-center mb-2">
              <small className="text-muted">Or reach us directly</small>
            </div>
            <div className="d-flex gap-2">
              <a
                href="mailto:meetify.co.in@gmail.com"
                className="btn btn-outline-primary btn-sm flex-fill"
                style={{ borderRadius: 8, fontSize: '0.8rem' }}
              >
                <FaEnvelope className="me-1" /> Email Us
              </a>
              <a
                href="https://wa.me/91XXXXXXXXXX?text=Hi%20Meetify%20Support%2C%20I%20need%20help%20with..."
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-success btn-sm flex-fill"
                style={{ borderRadius: 8, fontSize: '0.8rem' }}
              >
                <FaWhatsapp className="me-1" /> WhatsApp
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div>
        <Container className="py-5">
          {/* Header Section */}
          <Row className="text-center mb-5">
            <Col>
              <h1 className="display-5 fw-bold text-primary mb-3">
                <FaHeadset className="me-3" />
                Help & Support Center
              </h1>
              <p className="lead text-muted">
                We're here to help you! Get in touch with our support team for any assistance.
              </p>
            </Col>
          </Row>

          {/* Support Team Section */}
          <Row className="mb-5">
            <Col>
              <h2 className="h3 text-center mb-4">
                <FaUsers className="me-2 text-primary" />
                Meet Our Team
              </h2>
              <Row>
                {teamMembers.map((member, index) => (
                  <Col key={index} lg={3} md={6} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm team-card">
                      <Card.Body className="text-center p-4">

                        <h5 className="card-title text-dark mb-2">{member.name}</h5>
                        <p className="text-primary mb-2">{member.role}</p>
                        <div className="contact-info">
                          <div className="d-flex align-items-center justify-content-center mb-2">
                            <FaEnvelope className="text-muted me-2" />
                            <a href={`mailto:${member.email}`} className="text-decoration-none">
                              {member.email}
                            </a>
                          </div>
                          {/* <div className="d-flex align-items-center justify-content-center">
                        <FaPhone className="text-muted me-2" />
                        <span className="text-muted">{member.phone}</span>
                      </div> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Support Options */}
          <Row className="mb-5">
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm text-center">
                <Card.Body className="p-4">
                  <div className="icon-wrapper bg-primary rounded-circle mx-auto mb-3">
                    <FaEnvelope className="text-white" size={24} />
                  </div>
                  <h5>Email Support</h5>
                  <p className="text-muted">Send us an email and we'll get back to you within 24 hours.</p>
                  <Button variant="outline-primary" href="mailto:meetify.co.in@gmail.com">
                    Email Us
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm text-center">
                <Card.Body className="p-4">
                  <div className="icon-wrapper bg-success rounded-circle mx-auto mb-3">
                    <FaComments className="text-white" size={24} />
                  </div>
                  <h5>Live Chat</h5>
                  <p className="text-muted">Chat with our support team in real-time during business hours.</p>
                  <Button variant="outline-success" onClick={() => { setShowChat(true); setMessageSent(false); setSelectedAgent(null); }}>
                    <FaComments className="me-2" size={14} />
                    Start Chat
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm text-center">
                <Card.Body className="p-4">
                  <div className="icon-wrapper bg-warning rounded-circle mx-auto mb-3">
                    <FaClock className="text-white" size={24} />
                  </div>
                  <h5>Support Hours</h5>
                  <p className="text-muted">Monday - Friday: 9:00 AM - 6:00 PM IST</p>
                  <p className="text-muted mb-0">Saturday: 10:00 AM - 2:00 PM IST</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* FAQ Section */}
          {/* <Row className="mb-5">
        <Col lg={8} className="mx-auto">
          <h2 className="h3 text-center mb-4">
            <FaQuestionCircle className="me-2 text-primary" />
            Frequently Asked Questions
          </h2>
          <div className="accordion" id="faqAccordion">
            {faqItems.map((faq, index) => (
              <Card key={index} className="mb-3 border">
                <Card.Header className="bg-light">
                  <h5 className="mb-0">
                    <button
                      className="btn btn-link text-decoration-none w-100 text-start text-dark fw-bold"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#faq${index}`}
                    >
                      {faq.question}
                    </button>
                  </h5>
                </Card.Header>
                <div id={`faq${index}`} className="collapse" data-bs-parent="#faqAccordion">
                  <Card.Body>
                    {faq.answer}
                  </Card.Body>
                </div>
              </Card>
            ))}
          </div>
        </Col>
      </Row> */}

          {/* Contact Form */}
          {/* <Row>
        <Col lg={8} className="mx-auto">
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">
                <FaHeadset className="me-2" />
                Contact Support Team
              </h4>
            </Card.Header>
            <Card.Body className="p-4">
              <form>
                <Row>
                  <Col md={6} className="mb-3">
                    <label htmlFor="name" className="form-label">Your Name</label>
                    <input type="text" className="form-control" id="name" required />
                  </Col>
                  <Col md={6} className="mb-3">
                    <label htmlFor="email" className="form-label">Your Email</label>
                    <input type="email" className="form-control" id="email" required />
                  </Col>
                </Row>
                <div className="mb-3">
                  <label htmlFor="subject" className="form-label">Subject</label>
                  <input type="text" className="form-control" id="subject" required />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">Message</label>
                  <textarea className="form-control" id="message" rows="5" required></textarea>
                </div>
                <div className="text-center">
                  <Button variant="primary" size="lg" type="submit">
                    Send Message
                  </Button>
                </div>
              </form>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}

          <style>{`
        .team-card {
          transition: transform 0.3s ease;
        }
        
        .team-card:hover {
          transform: translateY(-5px);
        }
        
        .icon-wrapper {
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .member-photo img {
          transition: transform 0.3s ease;
        }
        
        .member-photo:hover img {
          transform: scale(1.05);
        }
        
        .contact-info a {
          color: #495057;
          transition: color 0.3s ease;
        }
        
        .contact-info a:hover {
          color: #007bff;
        }
        
        .btn {
          transition: all 0.3s ease;
        }

        .chat-agent-card {
          transition: all 0.2s ease;
        }

        .chat-agent-card:hover {
          box-shadow: 0 2px 8px rgba(13, 110, 253, 0.15);
        }

        .selected-agent {
          box-shadow: 0 2px 8px rgba(13, 110, 253, 0.25) !important;
        }
        
        @media (max-width: 768px) {
          .display-5 {
            font-size: 2rem;
          }
          
          .member-photo img {
            width: 100px;
            height: 100px;
          }
        }
        
        @media (max-width: 576px) {
          .container {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
      `}</style>
        </Container>
      </div>
    </>
  );
};

export default HelpCenter;